export default "__VITE_ASSET__DyWYNayc__"